/* Curlisse bundle widget v4 - native Shopify cart, no app. Tiers, per-unit color picker, add-ons, real delivery estimate. */
(function () {
  'use strict';
  var root, cfg, state = { tier: 0, picks: [], addons: {} };

  function money(c) {
    c = Math.round(c);
    if (cfg.currency) {
      try { return new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency: cfg.currency }).format(c / 100); } catch (e) {}
    }
    return '$' + (c / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; });
  }
  function tier() { return cfg.tiers[state.tier]; }
  function total() {
    var s = tier().price;
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) s += a.price; });
    return s;
  }
  function firstAvail() {
    for (var i = 0; i < cfg.variants.length; i++) if (cfg.variants[i].available) return cfg.variants[i].id;
    return cfg.variants[0] && cfg.variants[0].id;
  }
  function seedPicks() {
    var q = tier().qty, def = cfg.selected || firstAvail();
    var avail = cfg.variants.filter(function (v) { return v.available; });
    for (var i = 0; i < q; i++) {
      if (state.picks[i] == null) {
        // first unit = the print the shopper chose; extra units default to the next prints so the bundle shows variety
        var alt = avail.length ? avail[(avail.findIndex(function (v) { return v.id === def; }) + i) % avail.length] : null;
        state.picks[i] = i === 0 ? def : (alt ? alt.id : def);
      }
    }
    state.picks.length = q;
  }
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString(cfg.locale || 'en-US', { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); }
  }
  function urgencyHTML() {
    var h = '<div class="bbdl__urg">';
    if (cfg.deliveryMin && cfg.deliveryMax) {
      var now = new Date();
      h += '<p class="bbdl__eta"><span class="bbdl__dot"></span>Order today, arrives <b>' + fmtDate(addBusinessDays(now, cfg.deliveryMin)) + ' – ' + fmtDate(addBusinessDays(now, cfg.deliveryMax)) + '</b>' + (cfg.shipNote ? ' · ' + esc(cfg.shipNote) : '') + '</p>';
    }
    if (cfg.cutoff && new Date(cfg.cutoff) > new Date() && (new Date(cfg.cutoff) - new Date()) < (cfg.cutoffShowDays || 21) * 864e5) {
      h += '<p class="bbdl__cut">🎄 ' + esc(cfg.cutoffLabel || 'Order by') + ' <b>' + (cfg.cutoffText ? esc(cfg.cutoffText) : fmtDate(new Date(cfg.cutoff))) + '</b> ' + esc(cfg.cutoffSuffix || 'for Christmas delivery') + ' <span data-cd></span></p>';
    }
    return h + '</div>';
  }
  function countdown() {
    var lc = root.querySelector('[data-lcd]');
    if (lc && cfg.launchEnds) {
      var lm = new Date(cfg.launchEnds) - new Date();
      if (lm <= 0) { window.location.reload(); return; }
      var ld = Math.floor(lm / 864e5), lh = Math.floor(lm / 36e5) % 24, lmi = Math.floor(lm / 6e4) % 60, ls = Math.floor(lm / 1e3) % 60;
      lc.textContent = (ld ? ld + 'd ' : '') + String(lh).padStart(2, '0') + 'h ' + String(lmi).padStart(2, '0') + 'm ' + String(ls).padStart(2, '0') + 's';
    }
    var el = root.querySelector('[data-cd]'); if (!el || !cfg.cutoff) return;
    var ms = new Date(cfg.cutoff) - new Date(); if (ms <= 0) { el.textContent = ''; return; }
    var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
    el.textContent = '· ' + d + 'd ' + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's left';
  }
  function swatches(unit) {
    if (cfg.variants.length < 2) return '';
    var h = '<div class="bbdl__unit"><span class="bbdl__ul">' + esc(tier().qty > 1 ? (cfg.unitWord || 'Curler') + ' ' + (unit + 1) : (cfg.pickLabel || 'Color')) + '</span><span class="bbdl__sw">';
    cfg.variants.forEach(function (v) {
      var on = state.picks[unit] === v.id;
      h += '<button type="button" class="bbdl__chip' + (on ? ' is-on' : '') + (v.available ? '' : ' is-off') + '" data-unit="' + unit + '" data-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-pressed="' + on + '" title="' + esc(v.title) + '">' +
        (v.image ? '<img src="' + esc(v.image) + '" alt="" width="28" height="28" loading="lazy">' : '') + '<span>' + esc(v.title) + '</span></button>';
    });
    return h + '</span></div>';
  }
  function render() {
    seedPicks();
    var h = '';
    if (cfg.label) h += '<p class="bbdl__label"><span>' + esc(cfg.label) + '</span></p>';
    if (cfg.launchOn) h += '<p class="bbdl__launch">\uD83D\uDD25 <b>' + esc(cfg.launchLabel || 'Launch week prices') + '</b> end in <span data-lcd></span></p>';
    h += '<div class="bbdl__tiers">';
    cfg.tiers.forEach(function (tr, i) {
      var on = i === state.tier, per = tr.price / tr.qty, save = tr.compareAt && tr.compareAt > tr.price ? tr.compareAt - tr.price : 0;
      h += '<label class="bbdl__tier' + (on ? ' is-on' : '') + (tr.badge ? ' has-badge' : '') + '" data-tier="' + i + '">';
      if (tr.badge) h += '<span class="bbdl__badge">' + esc(tr.badge) + '</span>';
      h += '<span class="bbdl__row"><input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (on ? ' checked' : '') + '>';
      h += '<span class="bbdl__ht"><span class="bbdl__tt">' + esc(tr.title) + (save ? ' <em class="bbdl__save">Save ' + money(save) + '</em>' : '') + '</span>';
      if (tr.subtitle || tr.qty > 1) h += '<span class="bbdl__st">' + esc(tr.subtitle || '') + (tr.qty > 1 ? '<span class="bbdl__each">' + money(per) + ' each</span>' : '') + '</span>';
      h += '</span><span class="bbdl__pr"><span class="bbdl__p">' + money(tr.price) + '</span>';
      if (save) h += '<s class="bbdl__c">' + money(tr.compareAt) + '</s>';
      
      h += '</span></span>';
      if (on) { h += '<span class="bbdl__units">'; for (var u = 0; u < tr.qty; u++) h += swatches(u); h += '</span>'; }
      h += '</label>';
    });
    h += '</div>';
    if (cfg.addons && cfg.addons.length) {
      h += '<div class="bbdl__addons">';
      cfg.addons.forEach(function (a) {
        h += '<label class="bbdl__addon' + (state.addons[a.id] ? ' is-on' : '') + '"><input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' + (state.addons[a.id] ? ' checked' : '') + '>';
        if (a.image) h += '<img class="bbdl__thumb" src="' + esc(a.image) + '" alt="" loading="lazy" width="44" height="44">';
        h += '<span class="bbdl__ai"><span class="bbdl__an">' + esc(a.title) + '</span>' + (a.desc ? '<span class="bbdl__ad">' + esc(a.desc) + '</span>' : '') + '</span><span class="bbdl__ap">+' + money(a.price) + '</span></label>';
      });
      h += '</div>';
    }
    h += '<div class="bbdl__total"><span>' + esc(cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    h += '<button type="button" class="bbdl__cta">' + esc(cfg.ctaLabel || 'Add to cart') + '</button>';
    h += '<p class="bbdl__err">' + esc(cfg.errorText || 'Something went wrong. Please try again.') + '</p>';
    h += urgencyHTML();
    root.innerHTML = h;
    updateTotal(); countdown();
  }
  function updateTotal() {
    var t = root.querySelector('[data-total]'); if (!t) return;
    var tr = tier(), extra = '';
    if (tr.compareAt && tr.compareAt > tr.price) extra = '<s>' + money(tr.compareAt + (total() - tr.price)) + '</s> ';
    t.innerHTML = extra + money(total());
  }
  function drawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' && typeof d.getSectionsToRender === 'function' ? d : null;
  }
  function addToCart() {
    var btn = root.querySelector('.bbdl__cta'); root.classList.remove('has-error'); btn.disabled = true;
    var counts = {}, order = [];
    state.picks.forEach(function (id) { if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
    var items = order.map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 }); });
    var d = cfg.afterAdd === 'drawer' ? drawer() : null, body = { items: items };
    if (d) { try { body.sections = d.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; } catch (e) { d = null; } }
    fetch(cfg.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status >= 400) throw new Error('add failed');
        btn.disabled = false;
        if (d && res && res.sections) {
          try { d.renderContents(res); var cd = document.querySelector('cart-drawer'); if (cd && cd.classList.contains('is-empty')) cd.classList.remove('is-empty'); document.dispatchEvent(new CustomEvent('curlisse:added')); return; } catch (e) {}
        }
        window.location.href = cfg.afterAdd === 'checkout' ? cfg.routes.checkout : cfg.routes.cart;
      })
      .catch(function () { btn.disabled = false; root.classList.add('has-error'); });
  }
  function boot() {
    root = document.getElementById('bundle-builder');
    var el = document.getElementById('bundle-builder-config');
    if (!root || !el) return;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length || !cfg.variants || !cfg.variants.length) return;
    if (cfg.launchEnds && new Date() < new Date(cfg.launchEnds)) { cfg.launchOn = true; cfg.tiers.forEach(function (t) { if (t.launchPrice) t.price = t.launchPrice; }); }
    state.tier = Math.min(cfg.defaultTier || 0, cfg.tiers.length - 1);
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.classList.contains('bbdl__radio')) { state.tier = Number(t.value); render(); }
      else if (t.classList.contains('bbdl__cb')) { state.addons[t.getAttribute('data-addon')] = t.checked; t.closest('.bbdl__addon').classList.toggle('is-on', t.checked); updateTotal(); }
    });
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.bbdl__chip');
      if (chip) {
        e.preventDefault(); e.stopPropagation();
        var u = Number(chip.getAttribute('data-unit')), v = Number(chip.getAttribute('data-variant'));
        state.picks[u] = v;
        root.querySelectorAll('.bbdl__chip[data-unit="' + u + '"]').forEach(function (c) { var on = Number(c.getAttribute('data-variant')) === v; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); });
        if (u === 0) document.dispatchEvent(new CustomEvent('curlisse:print', { detail: { id: v } }));
        return;
      }
      if (e.target.closest('.bbdl__cta')) { e.preventDefault(); addToCart(); }
    });
    render();
    setInterval(countdown, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
